import classNames from 'classnames';

import type { PlaceholderProps } from './placeholder.props';

import './placeholder.scss';

function Placeholder({ className, inputId, hide, placeholder, size }: PlaceholderProps) {
  const classes = classNames('placeholder', `placeholder_${size}`, className);

  if (hide || !placeholder) {
    return null;
  }

  return inputId ? (
    <label className={classes} htmlFor={inputId}>
      {placeholder}
    </label>
  ) : (
    <span className={classes}>{placeholder}</span>
  );
}

export default Placeholder;
